import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import img1 from "../../assets/images/Image-1.svg";
import img2 from "../../assets/images/image-2.svg";
import img3 from "../../assets/images/image-3.svg";

const AboutSection: React.FC = () => {
  return (
    <section className="about-section">
      <Container>
        <Row className="align-items-center">
          {/* Left Images */}
          <Col md={6} className="image-collage">
            <div className="img-box img1">
              <img src={img1} alt="img1" />
            </div>
            <div className="img-box img2">
              <img src={img2} alt="img2" />
            </div>
          </Col>

          {/* Right Content */}
          <Col md={6}>
            <span className="about-badge">ABOUT US</span>
            <h2 className="about-title">
            Welcome to Core Semicon Technologies ,We focus customer oriented services with a high quality of team.
            </h2>

            <p>
            We commit on the quality and productivity from each and every aspect and view of customers.
            </p>

            <p>
            Having an Experienced team with 15+ years in vlsi .
            </p>

            <p>
            Working experience on SoC, servers groups, Graphics and gaming processors, mobile processor and on various IPs include DDR, GDDR, Serdes, HBM, PCIE, Ethernet etc…
            </p>
            <p>Our biggest advantage is experience on the multi-million gate designs and hands-on experience each stage of the flows with working experience on all the MNCs in the Industry</p>
            <p>Our engineering team is very strong in all CMOS & process technologies across all the foundries. And has expertise in a wide range of domains and advanced technology nodes including 3nm, 4nm,5nm, 7nm.10nm</p>
            <img src={img3} alt="img3" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;
